import { render, staticRenderFns } from "./BtnConvertir.vue?vue&type=template&id=2196ba4b&scoped=true"
import script from "./BtnConvertir.vue?vue&type=script&lang=js"
export * from "./BtnConvertir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196ba4b",
  null
  
)

export default component.exports